// src/universal/error-boundary/app-error.ts
var AppError = class extends Error {
  constructor(message, errorMessage, canRetry) {
    super(message);
    this.errorMessage = errorMessage;
    this.canRetry = canRetry;
    this.name = "AppError";
  }
};

export { AppError };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-AR63MRLK.mjs.map